import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Tour from 'reactour';
import { cleanupSettingsTour, setupSettingsTour } from 'redux/actions/tours';
import { saveTour } from 'redux/thunks';
import './TeamSettingsTour.scss';
interface TeamSettingsTourProps {
	open: boolean;
	onClose: () => void;
}

const TeamSettingsTour = (props: TeamSettingsTourProps) => {
	const { open, onClose } = props;
	const [interactionDisabled, setInteractionDisabled] = useState(true);
	const dispatch = useDispatch();
	
	const afterOpen = () => {
		dispatch(setupSettingsTour());
		dispatch(saveTour('TeamSettingsTour'));
	};
	
	const requestClose = () => {
		dispatch(cleanupSettingsTour());
		onClose();
	};
	
	// handles component dismounting
	useEffect(() => {
		return () => {
			dispatch(cleanupSettingsTour());
			dispatch(saveTour('TeamSettingsTour'));
        }
    }, [dispatch])

	const steps = [
		{
			selector: '',
			content: "This page is all about team settings. You can do a bunch of things from here, if you're an admin, of course",
		},
		{
			selector: '#teamName',
			content: 'Like change the team name',
		},
		{
			selector: '#permissionTable',
			content: 'Set whether everyone on the team can give tokens.... or only admins can give tokens',
		},
		{
			selector: '#teamSettings',
			content: 'Or define some team settings',
		},
		{
			selector: '#privateSwitch',
			content: () => (
				<>
					<div>Like making the team private</div>
					<div className='team-settings-tour__paragraph'>
						Private teams are not able to be joined from just searching for them. To join a private team, an admin of that team must add the user
					</div>
				</>
			),
		},
		{
			selector: '#lockedSwitch',
			content: () => (
				<>
					<div>Or locking the team</div>
					<div className='team-settings-tour__paragraph'>
						When a team is locked, no one is able to send or receive tokens but the team is still joinable.
					</div>
				</>
			),
		},
		{
			selector: '#leaderboardSwitch',
			content: () => (
				<>
					<div>Last thing for settings...</div>
					<div className='team-settings-tour__paragraph'>
						You can also hide the leaderboard... kind of takes away the point of the app... but you do you
					</div>
					<div className='team-settings-tour__paragraph'>
						When you hide the leaderboard, the leaderboard in the top right corner of the screen is removed. Data is still captured incase you want
					</div>
				</>
			),
		},
		{
			selector: '.team-details__seasons',
			content: () => (
				<>
					<div>Now lets go over seasons</div>
					<div className='team-settings-tour__paragraph'>What are seasons in Tokens of Appreciation?</div>
					<div className='team-settings-tour__paragraph'>
						A Season is a period of time during which you want to track the giving and receiving of tokens. Some teams may want to keep track of
						tokens contributions for just a Program Increment (PI), the entire year, or perhaps indefinitely
					</div>
					<div className='team-settings-tour__paragraph'>When a team is first created it automatically begins its first "Season"</div>
				</>
			),
		},
		{
			selector: '#seasonName',
			content: () => (
				<>
					<div>At any time during the season you can set, or change, the seasons name</div>
				</>
			),
		},
		{
			selector: '#endSeasonButton',
			content: () => (
				<>
					<div>When you decide its time to end your season, you can end it with the "End Season" button</div>
					<div className='team-settings-tour__paragraph'>
						Be careful when ending a season, when a season is ended, the team is locked and no more tokens can be sent. To begin sending tokens
						again, you will need to start a new season. Starting a new season will clear the current token totals for each user.
					</div>
					<div className='team-settings-tour__paragraph'>This cannot be undone.</div>
				</>
			),
			action: () => {
				if (!interactionDisabled) {
					setInteractionDisabled(true);
				}
			},
		},
		{
			selector: '#badgesTab',
			content: () => (
				<>
					<div>Click Badges to continue the tour</div>
				</>
			),
			action: () => {
				setInteractionDisabled(false)
			},
		},
	];

	return (
		<Tour
			steps={steps}
			closeWithMask={false}
			disableFocusLock={true}
			disableInteraction={interactionDisabled}
			showCloseButton={true}
			disableKeyboardNavigation={['esc']}
			isOpen={open}
			accentColor='#8524AA'
			onAfterOpen={afterOpen}
			onRequestClose={requestClose}
		/>
	);
};

export default TeamSettingsTour;
